export const actions = {
    ADD_ASSIGMENT_ACTIVITY: 'ADD_ASSIGMENT_ACTIVITY',
    ADD_ASSIGMENT_SET_ACTIVITY: 'ADD_ASSIGMENT_SET_ACTIVITY',
    ADD_ASSIGMENT_GET_ACTIVITY: 'ADD_ASSIGMENT_GET_ACTIVITY',
    SET_ASSIGNMENT_DATA_DEFAULT: 'SET_ASSIGNMENT_DATA_DEFAULT',
    UPDATE_ASSIGNMENT_ACTIVITY: 'UPDATE_ASSIGNMENT_ACTIVITY',

    ASSIGMENT_TYPE_SET: 'ASSIGMENT_TYPE_SET',

    DELETE_ASSIGNMENT_ACTIVITY: 'DELETE_ASSIGNMENT_ACTIVITY',
    DELETE_ASSIGNMENT_SET_ACTIVITY: 'DELETE_ASSIGNMENT_SET_ACTIVITY',

    SEND_ASSINGMENT_SET: 'SEND_ASSINGMENT_SET',
    SEND_ASSIGNMENT_GET: 'SEND_ASSIGNMENT_GET',

    SET_GROUP_ID: 'SET_GROUP_ID',

    UPDATE_ASSIGNMENT_UPLOADEDCOUNT: 'UPDATE_ASSIGNMENT_UPLOADEDCOUNT',

    GET_ASSIGNMENT_STUDENT_LIST: 'GET_ASSIGNMENT_STUDENT_LIST',
    SET_ASSIGNMENT_STUDENT_LIST: 'SET_ASSIGNMENT_STUDENT_LIST',

    GET_MY_ASSIGNMENTS: 'GET_MY_ASSIGNMENTS',
    SET_MY_ASSIGNMENTS: 'SET_MY_ASSIGNMENTS'
};